import { defineComponent, h, PropType } from 'vue';
import { Option } from '@vaaas/fpts/option';
import { Button } from '@phi/components';

export default defineComponent({
    props: {
        label: {
            required: false,
            type: String,
            default: 'Select file...'
        },
        accept: {
            required: false,
            type: String,
            default: '.phi'
        },
        value: {
            required: true,
            type: null as any as PropType<Option<File>>,
        },
    },

    emits: {
        'update:value': (x: File) => true,
    },

    methods: {
        on_change(x: InputEvent) {
            const target = x.target;
            if (!(target instanceof HTMLInputElement))
                return;
            if (!target.files)
                return;
            const file = target.files[0];
            if (!file)
                return;
            this.$emit('update:value', file);
        },

        on_click() {
            const input: unknown = this.$refs.input;
            if (!(input instanceof HTMLInputElement)) return;
            input.click();
        },
    },

    watch: {
        value(value: typeof this.value) {
            if (!this.$refs.input)
                return;
            else if (value === undefined)
                (this.$refs.input as HTMLInputElement).value = '';
        },
    },

    render() {
        return h('label', { class: 'file-input' }, [
            h(Button, { onClick: this.on_click },
                () => this.value ? this.value.name : this.label),

            h('input', {
                ref: 'input',
                type: 'file',
                class: 'sr-only',
                accept: this.accept,
                onChange: this.on_change,
            })
        ]);
    }
});
